import {
  FETCH_TOURNAMENT_REQUESTED,
  FETCH_TOURNAMENT_SUCCESS,
  FETCH_TOURNAMENT_FAILURE,
  FETCH_EVENTS_SUCCESS,
  FETCH_EDITIONS_SUCCESS,
  FETCH_ROUNDS_SUCCESS,
} from 'constants/actions'

const initialState = {
  isLoading: false,
  isError: false,
  matches: [],
  events: [],
  editions: [],
  rounds: [],
}

const reducer = (state = initialState, { type, data }) => {
  switch (type) {
    case FETCH_TOURNAMENT_REQUESTED:
      return {
        ...state,
        isLoading: true,
        isError: false,
      }
    case FETCH_TOURNAMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        matches: data.matches,
      }
    case FETCH_TOURNAMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      }
    case FETCH_EVENTS_SUCCESS:
      return { ...state, events: data }
    case FETCH_EDITIONS_SUCCESS:
      return { ...state, editions: data }
    case FETCH_ROUNDS_SUCCESS:
      return { ...state, rounds: data }
    default:
      return state
  }
}

export default reducer
